import { Component, Input, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ReportingService } from '../../../../reporting/reporting.service';
import { DateTime } from 'luxon';
import { saveAs } from '@progress/kendo-file-saver';
import { Platform } from '@angular/cdk/platform';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-unit-history-download-modal',
  templateUrl: './unit-history-download-modal.component.html',
  styleUrls: ['./unit-history-download-modal.component.scss'],
  imports: [
    MatSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    MatDialogModule,
  ],
  providers: [],
})
export class UnitHistoryDownloadModalComponent {
  private rptSvc = inject(ReportingService);
  private pltfrm = inject(Platform);
  private dialogRef =
    inject<MatDialogRef<UnitHistoryDownloadModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  @Input() baseUrl;

  startDate = new Date(
    DateTime.now().minus({ days: 30 }).toFormat('MM/dd/yyyy')
  );
  endDate = new Date();
  loading = false;

  downloadUnitHistoryReport() {
    this.endDate.setDate(this.endDate.getDate() + 1);
    // Adding one day to the endDate to get records on the original endDate itself.
    // (the generated data previously would not include data from the original endDate)
    // This may need to move to the backend but this is a quick fix for now.
    const start = DateTime.fromJSDate(this.startDate).toUTC().toISO();
    const end = DateTime.fromJSDate(this.endDate).toUTC().toISO();
    if (this.data.unitManagement) {
      this.rptSvc
        .getUnitManagementChanges(this.data.unit, start, end)
        .subscribe(resp => {
          this.saveReport(resp, start, end, 'management');
        });
    } else {
      this.rptSvc
        .getUnitProfileChanges(this.data.app, this.data.unit, start, end)
        .subscribe(resp => {
          this.saveReport(resp, start, end, 'history');
        });
    }
  }

  saveReport(resp, start, end, fileCategory) {
    const filename = `${this.data.unit}_${start}_${end}_${fileCategory}_report.pdf`;
    const iosSafari =
      this.pltfrm.IOS ||
      (navigator?.['userAgentData']?.platform === 'macOS' &&
        navigator.maxTouchPoints > 1);
    let fileData;
    const reader = new FileReader();

    reader.readAsDataURL(resp);
    reader.onloadend = () => {
      fileData = reader.result;
      saveAs(fileData, filename, {
        proxyURL: `${this.baseUrl}/util/proxy`,
        proxyTarget: '_self',
        forceProxy: iosSafari,
      });
      this.close();
    };
  }

  close() {
    this.dialogRef.close({ data: 'cancel' });
  }
}
